module.exports = __webpack_public_path__ + "img/home02.1b24120e.png";